import { CCard, CCardBody } from '@coreui/react'
import HandshakeIcon from '@mui/icons-material/Handshake'
import round from 'lodash/round'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import useNumberFormatter from 'src/hooks/i18n/useNumberFormatter'
import { ReactComponent as TreeIcon } from '../../assets/dashboard_icons/tree.svg'
import AccountCard from '../AccountCard/AccountCard'
import MarketingImage from '../MarketingImg/MarketingImg'
import styles from './accountrow.module.scss'

/**
 * @param {Object} props
 * @param {string} props.accountName
 * @param {string} props.accountNumber
 * @param {string} props.accountStatus
 * @param {Object} props.accountCreated
 * @param {Object} props.clientSince
 * @param {number} props.totalTreeContributions
 */
const AccountRow = ({
  accountName,
  accountNumber,
  accountStatus,
  accountCreated,
  clientSince,
  totalTreeContributions,
}) => {
  const { t } = useTranslation('common')
  const { format } = useNumberFormatter()

  const treeContributions = round(totalTreeContributions || 0)
  const formattedTreeContributions = format(treeContributions)

  return (
    <div className={styles.parentDiv}>
      <div className={styles.middleColPadding}>
        <AccountCard
          accountName={accountName}
          accountNumber={accountNumber}
          accountStatus={accountStatus}
          accountCreated={accountCreated}
        />
      </div>
      <div className={styles.middleColPadding}>
        <CCard className={styles.clientCard}>
          <CCardBody style={{ padding: '0px', display: 'grid', gridTemplateColumns: '1fr' }}>
            <div className={styles.contentContainerDiv}>
              <div className={styles.cardColDashBoardIcons}>
                <HandshakeIcon sx={{ fontSize: '4rem' }} />
              </div>
              <div>
                <div className={styles.cardDashBoardTitle}>
                  {clientSince.isValid() ? moment(clientSince).format('YYYY') : '#'}
                </div>
                <div className={styles.cardDashBoardDetails}>
                  {t('components.cards.account.clientSince')}
                </div>
              </div>
            </div>
            <div className={styles.contentContainerDiv}>
              <div className={styles.cardColDashBoardIcons}>
                <TreeIcon className={styles.cardDashBoardIcons} />
              </div>
              <div>
                <div className={styles.cardDashBoardTitle}>{formattedTreeContributions}</div>
                <div className={styles.cardDashBoardDetails}>
                  {t('components.cards.account.treeContributions')}
                </div>
              </div>
            </div>
          </CCardBody>
        </CCard>
      </div>
      <div className={styles.middleColPadding}>
        <CCard className={styles.imageCardStyle}>
          <MarketingImage accountNumber={accountNumber} />
        </CCard>
      </div>
    </div>
  )
}

AccountRow.defaultProps = {
  accountName: '',
  accountNumber: '',
  accountStatus: '',
  accountCreated: {},
  clientSince: {},
  totalTreeContributions: 0,
}

AccountRow.propTypes = {
  accountName: PropTypes.string,
  accountNumber: PropTypes.string,
  accountStatus: PropTypes.string,
  accountCreated: PropTypes.object,
  clientSince: PropTypes.object,
  totalTreeContributions: PropTypes.number,
}

export default AccountRow
